import React, { useState, useEffect } from "react";
import styled from "styled-components";
import logo from "../assets/images/sova_orange_login.png";
import { Link, useNavigate } from "react-router-dom";
import { getUser } from "../utils/Common";
import { Badge } from 'primereact/badge';

export const NavigationBar = ( props ) => {
  let navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [neprocitanePoruke, setNeprocitanePoruke] = useState([]);

  useEffect(() => {
    if ( sessionStorage.getItem("ustanova") !== null && sessionStorage.getItem("ustanova") === "pouz.hr") {
      fetch(
        props.rest +
          sessionStorage.getItem("ustanova") +
          "&prema_obliku=" +
          sessionStorage.getItem("premaObliku") +
          "&godina_upisa=" +
          sessionStorage.getItem("godinaUpisa") +
          "&redni_broj=" +
          sessionStorage.getItem("redniBroj"),
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return null;
        }
      })
      .then((data) => {
        setNeprocitanePoruke([]);
        data.forEach( poruka => {
          if (poruka.posiljatelj_je_polaznik !== true && poruka.vrijeme_citanja === null) {
            setNeprocitanePoruke(neprocitanePoruke => [...neprocitanePoruke, poruka]);
          }
        })
      })
      .catch((err) => {
      });
    }
  }, [navigate, props.rest]);

  return (
    <div className="navigation-bar-nav">
      <div className="navigation-bar-container">
        <div className="navigation-bar-logo-hamburger">
          <img
            src={logo}
            alt="Logo"
            className="navigation-bar-logo logo-img"
            height={30}
            onClick={() => {
              setIsOpen(!isOpen);
              navigate("/");
            }}
          />
          <div
            className="navigation-bar-hamburger"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Menu className="navigation-bar-menu" isOpen={isOpen}>
          <div
            className="navigation-bar-linkwrapper"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            {getUser() === null ? (
              <Link to="/login" className="p-link navigation-bar-link">
                Prijava{" "}
              </Link>
            ) : (
              <>
                <Link to="/ocjene" className="p-link navigation-bar-link">
                  Ocjene{" "}
                </Link>
                <Link to="/zavrsneOcjene" className="p-link navigation-bar-link">
                  ZavrsneOcjene{" "}
                </Link>
                <Link to="/ispiti" className="p-link navigation-bar-link">
                  Ispiti{" "}
                </Link>
                <Link to="/biljeske" className="p-link navigation-bar-link">
                  Bilješke{" "}
                </Link>
                <Link to="/izostanci" className="p-link navigation-bar-link">
                  Izostanci{" "}
                </Link>
                <Link to="/raspored" className="p-link navigation-bar-link">
                  Raspored
                </Link>
                {/*sessionStorage.getItem("ustanova") != null && ( sessionStorage.getItem("ustanova") === "pouz.hr" || sessionStorage.getItem("ustanova") === "test.hr" ) ? 
                <>
                  <Link to="/nastavni_materijali" className="p-link navigation-bar-link">
                    Nastavni materijali
                  </Link>
                  <Link to="/poruke" className="p-link navigation-bar-link">
                    Poruke{" "}{neprocitanePoruke.length > 0 ? <Badge value={neprocitanePoruke.length}></Badge> : ""}
                  </Link>
                </>
                : <></>*/}
                <Link to="/logout" className="p-link navigation-bar-link">
                  Odjava
                </Link>
              </>
            )}
          </div>
        </Menu>
      </div>
    </div>
  );
};

export default NavigationBar;

const Menu = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? "300px" : "0px")};
`;
